import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.function.name.js";
import { mapGetters } from "vuex";
import { get } from "vuex-pathify";
import MlHeader from "./components/MlHeader";
import MlFooter from "./components/MlFooter";
import SnackBar from "./components/SnackBar";
import FloatingChat from "./components/FloatingChat";
import DialogPush from "./components/DialogPush";
import DialogOptInWhatsapp from "./components/DialogOptInWhatsapp";
var versao = require("@/../package.json").version;
export default {
  name: "App",
  components: {
    MlHeader: MlHeader,
    MlFooter: MlFooter,
    SnackBar: SnackBar,
    FloatingChat: FloatingChat,
    DialogPush: DialogPush,
    DialogOptInWhatsapp: DialogOptInWhatsapp
  },
  data: function data() {
    return {
      versao: versao
    };
  },
  computed: _objectSpread(_objectSpread({
    cliente: get("auth/cliente")
  }, mapGetters("auth", ["carregandoTema", "identificador"])), {}, {
    /** Retorna o nome da classe para ser usado no <v-app> */classeCss: function classeCss() {
      if (!this.$route || !this.$route.name) {
        return "";
      }
      return "pagina-" + this.$route.name.toLowerCase();
    },
    loginSemAutosservico: function loginSemAutosservico() {
      return this.$route.name == "LoginDocumento" && this.cliente.nome && !this.cliente.autosservico;
    }
  })
};